var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobAvenShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 706.65 706.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #d9faff;\n      }\n\n      .cls-2 {\n        fill: #fff145;\n      }\n\n      .cls-3 {\n        fill: #b1e1e5;\n      }\n\n      .cls-4 {\n        fill: aqua;\n      }\n\n      .cls-5 {\n        fill: #c9ecf2;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "564.43 373.8 529.41 379.06 456.55 379.06 456.55 317.04 564.43 333.24 564.43 373.8"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "568.63 269.39 285.9 305.15 1.99 367.07 507.85 368.65 568.63 269.39"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "502.67 394.49 59.09 387.18 1.99 367.07 505.59 369.01 502.67 394.49"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "582.66 470.32 371.31 444.77 352.23 430.1 577.11 453.78 582.66 470.32"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "394.06 417.57 136.49 407.28 136.49 402.64 394.06 392.35 394.06 417.57"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "577.61 453.78 352.7 430.58 322.23 368.71 507.47 369.01 577.61 453.78"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "285.9 305.15 403.66 236.32 704.66 236.32 629.66 260.32 285.9 305.15"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "507.85 368.65 222.66 368.32 146.66 322.32 567.38 269.44 507.85 368.65"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "629.66 260.32 285.66 305.32 507.54 369.86 629.66 260.32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobAvenShip);
export default __webpack_public_path__ + "static/media/mob-aven-ship.17a712dbacd8ed24ea44f76a11b6d119.svg";
export { ForwardRef as ReactComponent };